import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpErrorResponse, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';

import { Observable, EMPTY, throwError, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertService } from '../services/alert.service';
import { AlertContext } from '../models/enums/alert-context.enum';
import { Alert } from '../models/alert';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(private router: Router, private alertService: AlertService, private authenticationService: AuthenticationService) {
    }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.error instanceof Error) {
                    // A client-side or network error occurred. Handle it accordingly.
                    console.error('An error occurred:', error.error.message);
                }
                else {
                    // The backend returned an unsuccessful response code.
                    // The response body may contain clues as to what went wrong. The body is often an
                    // object (e.g. { message: "..." }), so unwrap it instead of logging "[object Object]".
                    const errorBody =
                        typeof error.error === "string"
                            ? error.error
                            : error.error?.message ?? JSON.stringify(error.error);
                    console.error(`Backend returned code ${error.status}, body was: ${errorBody}`);

                    if (error instanceof HttpErrorResponse) {
                        if (error.status == 401) {
                            // Only force logout if the user is currently authenticated.
                            // An anonymous user hitting a protected endpoint (e.g. a stray API call
                            // from a public page) should not be kicked into a login redirect loop.
                            if (this.authenticationService.isAuthenticated()) {
                                this.authenticationService.forcedLogout();
                            }
                        }
                        if (error.status == 403) {
                            // Surface the server's 403 message as a Danger alert and let the originating
                            // component handle the error (rethrown below) so it stays mounted to report it.
                            // Previously every 403 forced navigation to /subscription-insufficient — a
                            // migration artifact (this app has no subscription concept) that tore down the
                            // Record Offline Payment modal before it could show the failure (LTINFO-2860 Bug 2).
                            if (typeof error.error === "string" && error.error.length > 0) {
                                this.alertService.pushAlert(new Alert(error.error, AlertContext.Danger));
                            }
                        }
                        if (error.status == 404) {
                            // Only handle 404s from our own API — external requests (GeoServer, etc.) should pass through
                            const isOurApi = error.url?.includes('/api/');
                            if (!isOurApi) {
                                return throwError(error);
                            }

                            if(typeof error.error === "string" && error.error.includes("User with GUID "))
                            {
                                // we want the login-callback to create the user to trigger so we just let it pass through and have authentication-service handle it
                                return throwError(error);
                            }
                            else
                            {
                                this.router.navigateByUrl("/not-found", { replaceUrl: false}).then(x => {
                                    if(typeof error.error === "string") {
                                        this.alertService.pushAlert(new Alert(error.error, AlertContext.Danger));
                                    }
                                });
                            }
                        }
                    }
                }

                // If you want to return a new response:
                //return of(new HttpResponse({body: [{name: "Default value..."}]}));

                // If you want to return nothing:
                //return EMPTY;

                // Otherwise pass it on to the upper level and let them take care of it:
                return throwError(error);
            })
        );
    }
}